import React, { useState, useEffect, useRef } from "react";
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Toolbar,
  Typography,
  Checkbox,
  IconButton,
  Select,
  MenuItem,
  Tooltip,
  FormControl,
  InputLabel,
  TextField,
  Chip,
  ThemeProvider,
  Button,
  Avatar,
  OutlinedInput,
} from "@mui/material";
import { LocalizationProvider, DateRangePicker } from "@mui/x-date-pickers-pro";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
// import { Box, TextField } from "@mui/material";
import dayjs from "dayjs";
import { debounce } from "lodash";
import DeleteIcon from "@mui/icons-material/Delete";
import useDarkTheme from "../Theme/useDarkTheme";
import LinearIndeterminate from "../Components/LinearIndeterminate";
import { formatDate } from "../Utils/Formatedate";
import { useNavigate } from "react-router-dom";
import {
  fetchAdminList,
  fetchAgencyList,
  fetchCategoriesList,
  fetchGifts,
  fetchPermisionList,
  fetchPk,
  fetchProducts,
  fetchTagList,
  fetchUserList,
  searchUser,
  fetchBussinessDevelopersList,
  GetRcoinsHistory,
  GetSenderLevelList,
  GetHostsLevelList,
  GetDiamondsPackagesList,
  GetAllMoments,
  GetApproveMoments,
  GetFamilyList,
  GetAllImages,
  GetAllRIDList,
  GetProfiletag,
  fetchAssignTagUsersList,
  GetDiamondList,
  GetProfileTagUsersList,
  GetSenderLevelUsersList,
  GetHostLevelUsersList,
  GetWithdrawList,
  GetReportList,
  GetDeactivateUserList,
  GetBannedUserList,
  GetGiftHistoryList,
  fetchMerchand,
  GetHostList,
  DeactiveBannerList,
  BannersListApi,
  ActiveBannersListApi,
  GetVideoApproveMoments,
  ResellerList,
  CustomerList,
  CustomerCSR,
  GetDonationList,
  GetWalletList,
  fetchGifterHistoryList,
  GetHostRankList,
  GetGiftRankList,
  GetReportMoments,
  GetFamilyReportList,
  GetWithdrawalsReportList,
  GetSvip,
  GetUserReportList,
  GetInviteRankList,
  GetFamilyRuleList,
  GetWithdrawalsRequestList,
  fetchUserProfileList,
} from "../DAL/fetch";
import {
  deleteAdmin,
  deleteAgency,
  DeleteBannerData,
  DeleteBannerImage,
  deleteCategory,
  deleteDiamondPackage,
  deleteFamily,
  deleteFamilyRule,
  deleteGift,
  deleteHostLevel,
  deleteMerchant,
  deletePermision,
  deletePk,
  deleteProducts,
  DeleteProfileTag,
  DeleteProfileUserTag,
  deleteSenderLevel,
  DeleteSpecialRid,
  deleteStreamTag,
  deleteSvip,
  deleteTag,
  deleteWithdrawPayment,
} from "../DAL/delete";

import AlertDialog from "../Components/Models/AlertDialog";
import AddPermision from "./Models/AddPermision";
import AddCategories from "./Models/AddCategories";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import SVGAAnimation from "./SVGAAnimation";
import { fileUrl, videoURL } from "../Config/Config";
import AddTag from "./Models/AddTag";
import {
  UpdateAgencyStatus,
  UpdateBannerStatusApi,
  UpdateCustomerStatusApi,
  updateMomentStatus,
  updateMomentVideoStatus,
  updateStatusData,
  updateUSerProfileStatus,
} from "../DAL/create";
import ReasonDialog from "./Models/ReasonModel";
import ImagesDialog from "./Models/ShowImages";
import {
  AssingnDeactive,
  updateFamilyStatus,
  updateMerchantStatus,
  UpdateResellerStatus,
  updateUnBanUser,
} from "../DAL/update";
import AssignTagDialog from "./Models/AssignTag";
import AssignProfileTagDialog from "./Models/ProfileTagAssign";
import moment from "moment";
import { enqueueSnackbar } from "notistack";
import CountryDropdown from "./CountryDropdown";
import DatePicker from "react-datepicker";

import "react-datepicker/dist/react-datepicker.css";

const transactionTypes = [
  "withdraw_diamond",
  "recharge_diamond",
  "exchange_rs_to_diamond",
  "exchange_point_to_rcoin",
  "send_diamond_by_reseller",
  "send_diamond_by_admin",
  "donation_rcoin",
  "sent_diamond_to_users",
  "send_rcoin_by_reseller",
  "send_rcoin_by_admin",
  "sent_rcoin_to_users",
  "invitation_reward",
  "initial_invitation_reward",
  "send_diamond_by_merchant",
  "create_family",
  "send_audio_message",
  "lucky_box_reward",
  "host_ranking_reward",
  "gifter_ranking_reward",
  "family_creation_refund",
  "remove_host_from_agency",
  "guardian_reward",
  "svip_reward",
  "send_video_lucky_gift",
  "receive_video_lucky_gift",
];

const statuses = ["waiting", "decline", "paid", "done", "paying", "report"];
export function useTable({
  headCells,
  type,
  limitPerpage,
  pageRowslinit,
  dataFromparent,
  id,
}) {
  const navigate = useNavigate();
  const [selected, setSelected] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(limitPerpage || 10);
  const [searchTerm, setSearchTerm] = useState("");
  const [search, setSearch] = useState("");
  const [data, setData] = useState([]);
  const [levelInputs, setLevelInputs] = useState({});
  const [imagesData, setImagesData] = useState([]);
  const [totalRecords, setTotalRecords] = useState("");
  const [loading, setLoading] = useState(false);
  const [Modeltype, setModeltype] = useState("");
  const [Modeldata, setModelData] = useState("");
  const [rowsOptions, setRowsOptions] = useState(
    pageRowslinit || [5, 10, 25, 100, 500]
  );
  const [openDialog, setOpenDialog] = useState(false);
  const [openAddPermisionDialog, setOpenAddPermisionDialog] = useState(false);
  const [openAddCategoriesDialog, setOpenAddCategoriesDialog] = useState(false);
  const [openAddTagDialog, setOpenAddTagDialog] = useState(false);
  const [openReasonModel, setOpenReasonModel] = useState(false);
  const [openImageModel, setOpenImageModel] = useState(false);
  const [Reason, setReason] = useState("");
  const [MomentId, setMomentId] = useState("");
  const [openAssignTagModel, setOpenAssignTagModel] = useState(false);
  const [bannerType, setBannerType] = useState("");
  const [country, setCountry] = useState("");
  const [historyType, setHistoryType] = useState("all");
  const [gifterRanking, setGifterRanking] = useState("Host");
  const [subType, setSubType] = useState("audio");
  const [donationtype, setDonationType] = useState("sent");
  const [rid, setRid] = useState("");
  const [selectedType, setSelectedType] = useState("");
  const [familyStatus, setFamilyStatus] = useState(id || "Pending");
  const [userProfile, setUserProfile] = useState("pending");
  const [filter, setFilter] = useState("today");
  const [currentCountry, setCurrentCountry] = useState("");
  const [withdrawStatus, setWithdrawStatus] = useState("waiting");
  const [startDate, setStartDate] = useState(new Date());
  const [formattedDate, setFormattedDate] = useState("");
  const [value, setValue] = useState([null, null]);

  const handleUnban = async (id) => {
    const resp = await updateUnBanUser(id);

    if (resp.status === 200) {
      enqueueSnackbar(resp?.data?.message, { variant: "success" });
      fetchData();
    } else {
      enqueueSnackbar(
        resp?.message,
        resp?.data?.message,
        resp?.error,
        resp?.data?.error,
        { variant: "error" }
      );
    }
  };
  const handleReactive = async (id) => {
    const resp = await AssingnDeactive(id);

    if (resp.status === 200) {
      enqueueSnackbar(resp?.data?.message, { variant: "success" });
      fetchData();
    } else {
      enqueueSnackbar(
        resp?.message,
        resp?.data?.message,
        resp?.error,
        resp?.data?.error,
        { variant: "error" }
      );
    }
  };

  const handleCountryChange = (selectedCountry) => {
    setCurrentCountry(selectedCountry);
  };

  const handleChangeTransaction = (event) => {
    setSelectedType(event.target.value);
  };
  const handleChangeGifterHistory = (event) => {
    setGifterRanking(event.target.value);
  };

  const handleSubmitRID = (e) => {
    e.preventDefault();
    fetchData();
    if (rid.trim().length === 0) {
      alert("Please enter a valid RID");
    }
    return;
  };

  const handleChangeDate = (event) => {
    setFilter(event.target.value);
  };
  const handleChangeStatusFamilies = (event) => {
    setFamilyStatus(event.target.value);
  };
  const handleChangeStatusUser = (event) => {
    setUserProfile(event.target.value);
  };
  const handleChange = (event) => {
    setHistoryType(event.target.value);
  };
  const handleChangeDatePK = (date) => {
    setStartDate(date);
    setFormattedDate(date.toISOString().split("T")[0]);
  };
  const handleChangeSubType = (event) => {
    setSubType(event.target.value);
  };
  const handleChangeDonationType = (event) => {
    setDonationType(event.target.value);
  };
  const start = value[0];
  const end = value[1];
  const formattedStart = start
    ? moment(start.toDate()).format("YYYY-MM-DD")
    : "";
  const formattedEnd = end ? moment(end.toDate()).format("YYYY-MM-DD") : "";
  const [openAssignProfileTagModel, setOpenAssignProfileTagModel] =
    useState(false);
  const svgaRef = useRef(null);

  const exportToExcel = (dataToExport, fileName = "export") => {
    if (!Array.isArray(dataToExport) || dataToExport.length === 0) {
      alert("No data to export");
      return;
    }

    const worksheet = XLSX.utils.json_to_sheet(dataToExport);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(blob, `${fileName}.xlsx`);
  };

  const exportTypes = [
    "Active Users",
    "Deleted Users",
    "Banned Users",
    "Scheduled PKs",
    "Join Agency Requests",
    "Send Diamonds",
    "Send Rcoins",
    "Gift",
    "Gifts Sent & Receive History",
    "Diamond Packages",
  ];

  const fetchData = async () => {
    setLoading(true);
    try {
      if (type === "Sub Admins") {
        const response = await fetchAdminList(
          page + 1,
          rowsPerPage,
          searchTerm
        );
        if (response && response.data) {
          setData(response.data.data || response.data);
          setTotalRecords(response.data.total || response.data?.length);
        }
      }
      if (type === "All Banners") {
        const response = await BannersListApi(
          page + 1,
          rowsPerPage,
          searchTerm
        );
        if (response && response.data) {
          const newData = response?.data?.data?.map((val) => {
            return {
              ...val,
              picture: val?.image?.url,
              screen: val?.image?.screen,
              link: val?.image?.link,
              startTime: moment(val?.startTime).format("YYYY-MM-DD hh:mm A"),
              endTime: moment(val?.endTime).format("YYYY-MM-DD hh:mm A"),
            };
          });
          setData(newData);
          setTotalRecords(response.data.total || response.data?.data?.length);
        }
      }
      if (type === "Inactive Banners") {
        const response = await DeactiveBannerList(
          page + 1,
          rowsPerPage,
          searchTerm
        );
        if (response && response.data) {
          const newData = response?.data?.data?.map((val) => {
            return {
              ...val,
              picture: val?.image?.url,
              screen: val?.image?.screen,
              link: val?.image?.link,
              startTime: moment(val?.startTime).format("YYYY-MM-DD hh:mm A"),
              endTime: moment(val?.endTime).format("YYYY-MM-DD hh:mm A"),
            };
          });
          setData(newData);
          setTotalRecords(response.data.total || response.data?.data?.length);
        }
      }
      if (type === "Active Banners") {
        const response = await ActiveBannersListApi(
          page + 1,
          rowsPerPage,
          searchTerm
        );
        if (response && response.data) {
          const newData = response?.data?.data?.map((val) => {
            return {
              ...val,
              picture: val?.image?.url,
              screen: val?.image?.screen,
              link: val?.image?.link,
              startTime: moment(val?.startTime).format("YYYY-MM-DD hh:mm A"),
              endTime: moment(val?.endTime).format("YYYY-MM-DD hh:mm A"),
            };
          });
          setData(newData);
          setTotalRecords(response.data.total || response.data?.data?.length);
        }
      }
      if (type === "Assign Sending Level") {
        const response = await GetSenderLevelUsersList(
          page + 1,
          rowsPerPage,
          searchTerm
        );
        if (response && response.data) {
          const resp = response?.data?.data?.map((val) => {
            return {
              ...val,
              code: val?.user_sender_level?.code,
              username: val?.user_sender_level?.name,
              pictureUrl: val?.user_sender_level?.picture,
              diamond: val?.totalDiamond,
              level: val?.level,
              now: val?.now,
              target: val?.target,
              created_at: moment.utc(val?.created).format("YYYY-MM-DD"),
            };
          });
          setData(resp);
          setTotalRecords(response.data.total || response.data?.length);
        }
      }
      if (type === "Assign Hosting Level") {
        const response = await GetHostLevelUsersList(
          page + 1,
          rowsPerPage,
          searchTerm
        );
        if (response && response.data) {
          const resp = response?.data?.data?.map((val) => {
            return {
              ...val,
              code: val?.userData?.code,
              username: val?.userData?.name,
              pictureUrl: val?.userData?.picture,
              rcoins: val?.rcoins,
              level: val?.level,
              created_at: moment.utc(val?.created).format("YYYY-MM-DD"),
            };
          });
          setData(resp);
          setTotalRecords(response?.data?.total || response?.data?.length);
        }
      }
      if (type === "Assign Profile Tags") {
        const response = await GetProfileTagUsersList(
          page + 1,
          rowsPerPage,
          searchTerm
        );
        if (response && response.data) {
          const newData = response.data?.data?.map((val) => {
            return {
              ...val,
              assignUsername: val?.user?.name,
              assignUserImage: val?.user?.picture,
              tagName: val?.tag?.type,
              assignImage: val?.tag?.pictureUrl,
            };
          });
          setData(newData);
          setTotalRecords(response.data.total);
        }
      }
      if (type === "Assign Livestream Tag") {
        const response = await fetchAssignTagUsersList(
          page + 1,
          rowsPerPage,
          searchTerm
        );
        if (response && response.data) {
          const newData = response?.data?.data?.map((val) => {
            return {
              ...val,
              code: val?.assignedUser?.code,
              assignUsername: val?.assignedUser?.name,
              assignUserImage: val?.assignedUser?.picture,
              adminName: val?.adminUser?.name,
              adminImage: val?.adminUser?.picture,
              tagName: val?.streamTag?.tagName,
              tagImage: val?.streamTag?.picture,
              expiredAt: moment(val?.expiredAt).format("YYYY-MM-DD hh:mm:ss A"),
            };
          });
          setData(newData);
          setTotalRecords(response.data.total);
        }
      }
      if (type === "Profile Tags") {
        const response = await GetProfiletag(page + 1, rowsPerPage, searchTerm);
        if (response && response.data) {
          setData(response.data.data || response.data);
          setTotalRecords(response.data.total);
        }
      }
      if (type === "Special RID") {
        const response = await GetAllRIDList(page + 1, rowsPerPage, searchTerm);
        if (response && response.data) {
          const newData = response?.data?.data?.map((val) => {
            return {
              ...val,
              pictureUrl: val?.picture?.url,
            };
          });
          setData(newData);
          setTotalRecords(response.data.total);
        }
      }
      if (type === "Images") {
        const response = await GetAllImages(page + 1, rowsPerPage, searchTerm);
        if (response && response.data) {
          setData(response.data.data || response.data);
          setTotalRecords(response.data.total);
        }
      }
      if (type === "All Moments") {
        const response = await GetApproveMoments(
          "all",
          page + 1,
          rowsPerPage,
          searchTerm
        );
        if (response && response.data) {
          const momentData = response?.data?.data?.map((val) => {
            return {
              ...val,
              picture: val?.likeuser?.picture,
              username: val?.likeuser?.name,
              country: val?.likeuser.country,
            };
          });
          setData(momentData);
          setTotalRecords(response.data.total);
        }
      }
      if (type === "Pending Moments") {
        const response = await GetApproveMoments(
          "pending",
          page + 1,
          rowsPerPage,
          searchTerm
        );
        if (response && response.data) {
          const newData = response.data?.data?.map((val) => {
            return {
              ...val,
              code: val?.likeuser?.code,
              picture: val?.likeuser?.picture,
              username: val?.likeuser?.name,
              country: val?.likeuser.country,
              imageUrl1: val?.pictureUrl?.[0],
            };
          });
          setData(newData);
          setTotalRecords(response.data.total || response.data.data.length);
        }
      }
      if (type === "Active Moments") {
        const response = await GetApproveMoments(
          "active",
          page + 1,
          rowsPerPage,
          searchTerm
        );
        if (response && response.data) {
          const newData = response?.data?.data?.map((val) => {
            return {
              ...val,
              code: val?.likeuser?.code,
              picture: val?.likeuser?.picture,
              username: val?.likeuser?.name,
              country: val?.likeuser.country,
            };
          });
          setData(newData);
          setTotalRecords(response.data.total || response.data.data.length);
        }
      }
      if (type === "Active Video Moments") {
        const response = await GetVideoApproveMoments(
          "approved",
          page + 1,
          rowsPerPage,
          searchTerm
        );
        if (response && response.data) {
          const newData = response?.data?.data?.map((val) => {
            return {
              ...val,
              code: val?.user?.code,
              picture: val?.user?.picture,
              username: val?.user?.name,
              country: val?.user.country,
              videoUrl: val?.url,
            };
          });
          setData(newData);
          setTotalRecords(response.data.total || response.data.data.length);
        }
      }
      if (type === "Pending Video Moments") {
        const response = await GetVideoApproveMoments(
          "pending",
          page + 1,
          rowsPerPage,
          searchTerm
        );
        if (response && response.data) {
          const newData = response?.data?.data?.map((val) => {
            return {
              ...val,
              code: val?.user?.code,
              picture: val?.user?.picture,
              username: val?.user?.name,
              country: val?.user.country,
              videoUrl: val?.url,
            };
          });
          setData(newData);
          setTotalRecords(response.data.total || response.data.data.length);
        }
      }
      if (type === "Rejected Video Moments") {
        const response = await GetVideoApproveMoments(
          "rejected",
          page + 1,
          rowsPerPage,
          searchTerm
        );
        if (response && response.data) {
          const newData = response?.data?.data?.map((val) => {
            return {
              ...val,
              code: val?.user?.code,
              picture: val?.user?.picture,
              username: val?.user?.name,
              country: val?.user.country,
              videoUrl: val?.url,
            };
          });
          setData(newData);
          setTotalRecords(response.data.total || response.data.data.length);
        }
      }
      if (type === "Rejected Moments") {
        const response = await GetApproveMoments(
          "rejected",
          page + 1,
          rowsPerPage,
          searchTerm
        );
        if (response && response.data) {
          const newData = response.data?.data?.map((val) => {
            return {
              ...val,
              code: val?.likeuser?.code,
              picture: val?.likeuser?.picture,
              username: val?.likeuser?.name,
              country: val?.likeuser.country,
            };
          });
          setData(newData);
          setTotalRecords(response.data.total || response.data.data.length);
        }
      }
      if (type === "Reported Moments") {
        const response = await GetReportMoments(
          searchTerm,
          page + 1,
          rowsPerPage
        );
        if (response && response.data) {
          const newData = response.data?.data?.map((val) => {
            return {
              ...val,
              reportname: val?.reporter?.name,
              reportcode: val?.reporter?.code,
              pictureUrl: val?.reporter?.picture,
              imageUrl1: val?.post?.pictureUrl || null,
              postUserCode: val?.post?.postUser?.name,
              postUserName: val?.post?.postUser?.code,
              picture: val?.post?.postUser?.picture,
            };
          });
          setData(newData);
          setTotalRecords(response.data.total || response.data.data.length);
        }
      }
      if (type === "Diamond Packages") {
        const response = await GetDiamondsPackagesList(page + 1, rowsPerPage);
        if (response && response.data) {
          setData(response.data?.data || response?.data);
          setTotalRecords(response.data.total);
        }
      }
      if (type === "Withdraw Payment Methods") {
        const response = await GetWithdrawList(page + 1, rowsPerPage);
        if (response && response.data) {
          const newData = response.data?.data?.map((val) => {
            return {
              ...val,
              pictureUrl: val?.picture?.url,
            };
          });
          setData(newData);
          setTotalRecords(response.data.total);
        }
      }
      if (type === "Withdraw Request") {
        const response = await GetWithdrawalsRequestList(
          searchTerm,
          page + 1,
          rowsPerPage,
          withdrawStatus
        );
        if (response && response.data) {
          const newData = response.data?.data?.map((val) => {
            return {
              ...val,
              userName: val?.user?.name,
              userCode: val?.user?.code,
              pictureUrl: val?.user?.picture,
              userEmail: val?.user?.email,
              user_payment_method_account:
                val?.user_payment_method?.fields?.account,
              user_payment_method_paymentMethod_name:
                val?.user_payment_method?.paymentMethod?.name,
              user_payment_method_paymentMethod_feePercentage:
                val?.user_payment_method?.paymentMethod?.feePercentage,
              user_payment_method_paymentMethod_type:
                val?.user_payment_method?.paymentMethod?.type,
              created:
                val?.status === "paid" || val?.status === "paying"
                  ? val?.submitAt
                  : val?.status === "waiting"
                  ? val?.created
                  : null,
              merchantRID:
                val?.status === "paid" || val?.status === "paying"
                  ? val?.merchant?.code
                  : "",
              merchantUserName:
                val?.status === "paid" || val?.status === "paying"
                  ? val?.merchant?.user_name
                  : "",
              merchantName:
                val?.status === "paid" || val?.status === "paying"
                  ? val?.merchant?.name
                  : "",
              Picture:
                val?.status === "paid" || val?.status === "paying"
                  ? val?.merchant?.picture
                  : "",
            };
          });
          setData(newData);
          setTotalRecords(response.data.total);
        }
      }
      if (type === "Withdrawals Report") {
        const response = await GetWithdrawalsReportList(
          searchTerm,
          page + 1,
          rowsPerPage
        );
        if (response && response.data) {
          const newData = response.data?.data?.map((val) => {
            return {
              ...val,
              pictureUrl: val?.image?.url,
              userName: val?.user?.name,
              userEmail: val?.user?.email,
              usercode: val?.user?.code,
              picture: val?.user?.picture,
              transactionstatus: val?.transaction?.status,
              transactionamount: val?.transaction?.amount,
              transactiondeductedTax: val?.transaction?.deductedTax,
              transactionrcoin: val?.transaction?.rcoin,
              transactionoriginalAmount: val?.transaction?.originalAmount,
              transactioncreated: moment
                .utc(val?.transaction?.created)
                .format("MMM D, YYYY h:mm A"),
              transactionsubmitAt: moment
                .utc(val?.transaction?.submitedAt)
                .format("MMM D, YYYY h:mm A"),
              user_payment_methodid:
                val?.transaction?.user_payment_method?.paymentMethod?.id,
              user_payment_methodtype:
                val?.transaction?.user_payment_method?.paymentMethod?.name,
              user_payment_methodname:
                val?.transaction?.user_payment_method?.paymentMethod?.type,
            };
          });
          setData(newData);
          setTotalRecords(response.data.total);
        }
      }
      if (type === "Join Agency Requests") {
        const response = await GetHostList(page + 1, rowsPerPage);
        if (response && response.data) {
          const newData = response.data?.data?.map((val) => {
            return {
              ...val,
              videoUrl: val?.type === "audio" ? "audio" : val?.videoLink,
              usercode: val?.user?.code,
              pictureUrl: val?.user?.coverImage,
              country: val?.user?.country,
              name: val?.user?.name,
              gender: val?.user?.gender,
              level: val?.user?.level,
              Agencyname: val?.agency?.name,
              Agencycountry: val?.agency?.country,
              rid: val?.agency?.rid,
              code: val?.agency?.code,
            };
          });
          setData(newData);
          setTotalRecords(response.data.total);
        }
      }
      if (rid) {
        if (type === "Donation Log") {
          const response = await GetDonationList(
            page + 1,
            rowsPerPage,
            rid,
            donationtype,
            formattedStart,
            formattedEnd,
            subType
          );
          if (response && response.data) {
            const newData = response.data?.data?.map((val) => {
              return {
                ...val,
                updated: moment(val?.updated).format("YYYY-MM-DD hh:mm"),
                targetusername: val?.targetUser?.name,
                targetusercode: val?.targetUser?.code,
                photoUrl: val?.targetUser?.picture,
                fromusername: val?.fromUser?.name,
                fromusercode: val?.fromUser?.code,
                pictureUrl: val?.fromUser?.picture,
                picture: val?.gift?.picture_url,
                giftname: val?.gift?.name,
                giftdiamond: val?.gift?.diamond,
                gifttype: val?.gift?.type,
              };
            });
            setData(newData);
            setTotalRecords(response.data.total);
          }
        }
      }
      if (type === "Host") {
        const response = await GetHostRankList(
          page + 1,
          rowsPerPage,
          filter,
          currentCountry
        );
        if (response && response.data) {
          const newData = response.data?.data?.map((val) => {
            return {
              ...val,
              usercode: val?.user?.code,
              username: val?.user?.name,
              pictureUrl: val?.user?.picture,
              userbirthday: val?.user?.birth_day,
              usercountry: val?.user?.country,
              userlevel: val?.user?.level,
              created: val?.user?.created,
            };
          });
          setData(newData);
          setTotalRecords(response.data.total);
        }
      }
      if (type === "Invite") {
        const response = await GetInviteRankList(page + 1, rowsPerPage);
        if (response && response.data) {
          const newData = response.data?.data?.map((val) => {
            return {
              ...val,
              picture: val?.picture,
            };
          });
          setData(newData);
          setTotalRecords(response.data.total);
        }
      }
      if (type === "Gift Rank") {
        const response = await GetGiftRankList(
          page + 1,
          rowsPerPage,
          filter,
          currentCountry
        );
        if (response && response.data) {
          const newData = response.data?.data?.map((val) => {
            return {
              ...val,
              pictureUrl: val?.picture,
              userbirthday: val?.user?.birth_day,
              usercountry: val?.user?.country,
            };
          });
          setData(newData);
          setTotalRecords(response.data.total);
        }
      }
      if (rid) {
        if (type === "Wallet Transaction") {
          const response = await GetWalletList(
            page + 1,
            rowsPerPage,
            rid,
            donationtype,
            formattedStart,
            formattedEnd,
            selectedType
          );
          if (response && response.data) {
            const newData = response.data?.data?.map((val) => {
              return {
                ...val,
                updated: moment(val?.updated).format("YYYY-MM-DD hh:mm"),
                targetusername: val?.toUser?.name,
                targetusercode: val?.toUser?.code,
                photoUrl: val?.toUser?.picture,
                fromusername: val?.fromUser?.name,
                fromusercode: val?.fromUser?.code,
                pictureUrl: val?.fromUser?.picture,
                giftdiamond: val?.wallet?.diamond,
                gifttype: val?.wallet?.rcoin,
              };
            });
            setData(newData);
            setTotalRecords(response.data.total);
          }
        }
      }
      if (type === "LiveStreams") {
        const response = await GetReportList(page + 1, rowsPerPage);
        if (response && response.data) {
          const newData = response.data?.data?.map((val) => {
            return {
              ...val,
              LiveID: val?.livestream?.id,
              LiveRoomID: val?.livestream?.roomId,
              LivehostName: val?.livestream?.hostName,
              Livetype: val?.livestream?.type,
              AudioID: val?.audiostream?.id,
              AudioRoomID: val?.audiostream?.roomId,
              AudiohostName: val?.audiostream?.hostName,
              ReportID: val?.reporterUser?.id,
              ReportCode: val?.reporterUser?.code,
              ReportName: val?.reporterUser?.name,
              pictureUrl: val?.reporterUser?.picture,
            };
          });
          setData(newData);
          setTotalRecords(response.data.total);
        }
      }
      if (type === "User Report") {
        const response = await GetUserReportList(
          searchTerm,
          page + 1,
          rowsPerPage
        );
        if (response && response.data) {
          const newData = response.data?.data?.map((val) => {
            return {
              ...val,
              reporterUserName: val?.reporterUser?.name,
              reporterUserCode: val?.reporterUser?.code,
              pictureUrl: val?.reporterUser?.picture,
              respondedUserName: val?.respondedUser?.name,
              respondedUserCode: val?.respondedUser?.code,
              picture: val?.respondedUser?.picture,
            };
          });
          setData(newData);
          setTotalRecords(response.data.total);
        }
      }
      if (type === "Gifts Sent & Receive History") {
        const response = await GetGiftHistoryList(page + 1, rowsPerPage);
        if (response && response.data) {
          const newData = response.data?.data?.map((val) => {
            return {
              ...val,
              UserID: val?.fromUser?.id,
              UserName: val?.fromUser?.name,
              UserCode: val?.fromUser?.code,
              pictureUrl: val?.fromUser?.picture,
              TargetID: val?.targetUser?.id,
              TargetName: val?.targetUser?.name,
              TargetCode: val?.targetUser?.code,
              picture: val?.targetUser?.picture,
              giftID: val?.gift?.id,
              giftName: val?.gift?.name,
              giftDiamond: val?.gift?.diamond,
              giftType: val?.gift?.type,
              assignUserImage: val?.gift?.picture_url,
              createdAt: moment.utc(val?.created).format("YYYY-MM-DD hh:mm"),
            };
          });
          setData(newData);
          setTotalRecords(response.data.total);
        }
      }
      if (type === "Deleted Users") {
        const response = await GetDeactivateUserList(
          page + 1,
          rowsPerPage,
          searchTerm
        );
        if (response && response.data) {
          const newData = response?.data?.data?.map((val) => {
            return {
              ...val,
              phone: String(val?.phone).slice(0, 18),
              deleted: moment(val?.deleted).format("YYYY-MM-DD  hh:mm A"),
            };
          });
          setData(newData);
          setTotalRecords(response.data.total || response.data?.data?.length);
        }
      }
      if (type === "Banned Users") {
        const response = await GetBannedUserList(page + 1, rowsPerPage);
        if (response && response.data) {
          const newData = response.data?.data?.map((val) => {
            return {
              ...val,
              pictureUrl: val?.proof,
              UserName: val?.user?.name,
              UserCode: val?.user?.code,
              picture: val?.user?.picture,
              time: moment.utc(val?.created).format("YYYY-MM-DD hh:mm A"),
            };
          });
          setData(newData);
          setTotalRecords(response.data.total);
        }
      }
      if (type === "Sending Level") {
        const response = await GetSenderLevelList(page + 1, rowsPerPage);
        if (response && response.data) {
          setData(response.data.data || response.data);
          setTotalRecords(
            response.data.total ||
              response.data.length ||
              response.data.data.length
          );
        }
      }
      if (type === "Hosting Level") {
        const response = await GetHostsLevelList(page + 1, rowsPerPage);
        if (response && response.data) {
          setData(response.data.data || response.data);
          setTotalRecords(
            response.data.total ||
              response.data.length ||
              response.data.data.length
          );
        }
      }
      if (type === "Send Rcoins") {
        const response = await GetRcoinsHistory(
          searchTerm,
          rowsPerPage,
          page + 1,
          formattedStart,
          formattedEnd
        );
        if (response && response.data) {
          const newData = response?.data?.data?.map((val) => {
            return {
              ...val,
              id: val?.userId,
              userPhone: String(val?.userPhone).slice(0, 18),
              reason: val?.reason
                ? String(val.reason).length > 18
                  ? String(val.reason).slice(0, 18) + "..."
                  : String(val.reason)
                : "N/A",
            };
          });
          setData(newData);
          setTotalRecords(response.data.total);
        }
      }
      if (type === "Families") {
        const response = await GetFamilyList(
          rowsPerPage,
          page + 1,
          familyStatus
        );
        if (response && response.data) {
          const newData = response?.data?.data?.map((val) => {
            return {
              ...val,
              phoneNumber: val?.phoneNumber.slice(0, 18),
              description: val?.description.slice(0, 18),
            };
          });
          setData(newData);
          setTotalRecords(response.data.total || response.data?.data?.length);
        }
      }
      if (type === "Family Rule") {
        const response = await GetFamilyRuleList(
          searchTerm,
          rowsPerPage,
          page + 1
        );
        if (response && response.data) {
          const newData = response?.data?.data?.map((val) => {
            return {
              ...val,
            };
          });
          setData(newData);
          setTotalRecords(response.data.total || response.data?.data?.length);
        }
      }
      if (type === "Family Report") {
        const response = await GetFamilyReportList(
          searchTerm,
          rowsPerPage,
          page + 1
        );
        if (response && response.data) {
          const newData = response?.data?.data?.map((val) => {
            return {
              ...val,
              familyname: val?.family?.name,
              familycode: val?.family?.code,
              picture: val?.family?.picture_url,
              familyno: val?.family?.phone_number.slice(0, 18),
              reporterUser: val?.reporterUser.name,
              reporterRID: val?.reporterUser.code,
              pictureUrl: val?.reporterUser.picture,
              respondedUser: val?.respondedUser.name,
              respondedcode: val?.respondedUser.code,
              adminImage: val?.respondedUser.picture,
            };
          });
          setData(newData);
          setTotalRecords(response.data.total || response.data?.data?.length);
        }
      }
      if (type === "Bussiness-developers") {
        const response = await fetchBussinessDevelopersList(
          rowsPerPage,
          page + 1
        );
        if (response && response.data) {
          setData(response.data.data || response.data);
          setTotalRecords(response.data.total);
        }
      }

      if (type === "Scheduled PKs") {
        const response = await fetchPk(
          page + 1,
          rowsPerPage,
          searchTerm,
          formattedDate
        );
        if (response && response.data) {
          const newData = response.data?.data?.map((val) => {
            return {
              ...val,
              picture1: val?.opponentOneUser?.picture,
              picture2: val?.opponentTwoUser?.picture,
              pkDate: formatDate(val?.pkDate),
            };
          });
          setData(newData);
          setTotalRecords(response.data.total);
        }
      }
      if (type === "Send Diamonds") {
        const response = await GetDiamondList(
          page + 1,
          rowsPerPage,
          formattedStart,
          formattedEnd,
          searchTerm,
          historyType
        );
        if (response && response.data) {
          const newData = response.data?.data?.map((val) => {
            return {
              ...val,
              createdAt: moment
                .utc(val?.created)
                .local()
                .format("YYYY-MM-DD hh:mm A"),
            };
          });
          setData(newData);
          setTotalRecords(response.data.total);
        }
      }
      if (type === "All Svip") {
        const response = await GetSvip(page + 1, rowsPerPage);
        if (response && response.data) {
          const newData = response.data?.data?.map((val) => {
            return {
              ...val,
              picture: val?.frame?.picture?.url,
              vipPrices: val?.vipPrices[0]?.pricing,
              animationUrl: val?.frame?.animation?.url,
              pictureUrl: val?.batch?.picture?.url,
              tagImage: val?.background?.picture?.url,
              canKick: val?.canKick,
              MiniProfile: val?.miniProfileColorful,
              canMute: val?.canMute,
              canLive: val?.canLive,
              adminImage: val?.nickname?.picture?.url,
            };
          });
          setData(newData);
          setTotalRecords(response.data.total);
        }
      }
      if (rid) {
        if (type === "Gifter Ranking") {
          const response = await fetchGifterHistoryList(
            rid,
            formattedStart,
            formattedEnd,
            gifterRanking
          );
          if (response && response.data) {
            const newData = response.data.data?.map((val) => {
              return {
                ...val,
                reward: Number(val.reward).toFixed(3),
                updated: moment(val?.updated).format("YYYY-MM-DD hh:mm A"),
                pictureUrl: val?.User.picture,
                name: val?.User.name,
                code: val?.User.code,
              };
            });
            setData(newData);
            setTotalRecords(response.data.total);
          }
        }
      }
      if (type === "Reseller") {
        const response = await ResellerList(page + 1, rowsPerPage, searchTerm);
        if (response && response.data) {
          setData(response.data.data || response.data);
          setTotalRecords(response.data.total || response.data.count);
        }
      }
      if (type === "Customer") {
        const response = await CustomerList(page + 1, rowsPerPage, searchTerm);
        if (response && response.data) {
          setData(response.data.data || response.data);
          setTotalRecords(response.data.total);
        }
      }
      if (type === "Customer List") {
        const response = await CustomerCSR(page + 1, rowsPerPage, searchTerm);
        if (response && response.data) {
          setData(response.data.data || response.data);
          setTotalRecords(response.data.total);
        }
      }
      if (type === "Live Stream Tags") {
        const response = await fetchTagList(page + 1, rowsPerPage, searchTerm);
        if (response && response.data) {
          setData(response.data.data || response.data);
          setTotalRecords(response.data.total);
        }
      }
      if (type === "Permissions") {
        const response = await fetchPermisionList(
          page + 1,
          rowsPerPage,
          searchTerm
        );
        if (response && response.data) {
          setData(response.data.data || response.data);
          setTotalRecords(response.data.total);
        }
      }
      if (type === "Active Users") {
        const filters = [];
        if (searchTerm) {
          filters.push(`code||$eq||${searchTerm}`);
        }
        filters.push(`banned||$eq||false`);

        const filterQuery = filters.join("&");
        const response = await fetchUserList(
          page + 1,
          rowsPerPage,
          filterQuery
        );
        if (response && response.data) {
          const newData = response?.data?.data?.map((val) => {
            return {
              ...val,
              phone: String(val?.phone).slice(0, 18),
            };
          });
          setData(newData);
          setTotalRecords(response.data.total || response.data?.data?.length);
        }
      }
      if (type === "Profile Users") {
        // const filters = searchTerm
        //   ? encodeURIComponent(`code||$eq||${searchTerm}`)
        //   : "";
        const response = await fetchUserProfileList(
          page + 1,
          rowsPerPage,
          userProfile
        );
        if (response && response.data) {
          const newData = response?.data?.data?.map((val) => {
            return {
              ...val,
              picture: val?.image,
              profileuser: val?.profileuser,
            };
          });
          setData(newData);
          setTotalRecords(response.data.total || response.data?.data?.length);
        }
      }
      if (type === "Product Categories") {
        const response = await fetchCategoriesList(
          page + 1,
          rowsPerPage,
          searchTerm
        );
        if (response && response.data) {
          setData(response.data.data || response.data);
          setTotalRecords(response.data.total);
        }
      }
      if (type === "AgencyUser") {
        setData(dataFromparent || []);
      }
      if (type === "Gift") {
        const response = await fetchGifts(page + 1, rowsPerPage);
        if (response && response.data) {
          const newData = response.data?.map((val) => {
            return {
              ...val,
              pictureUrl: val?.pictureUrl,
              animationUrl: val?.animationUrl,
            };
          });
          setData(newData);
          setTotalRecords(response.data.total);
        }
      }
      if (type === "Products") {
        const response = await fetchProducts(page + 1, rowsPerPage, searchTerm);
        if (response && response.data) {
          const newData = response.data.data?.map((val) => {
            return {
              ...val,
              picture: val?.picture.url,
              animationsurl: val?.animation.url,
              ProductCategory: val?.ProductCategory?.name,
            };
          });
          setData(newData);
          setTotalRecords(response.data.total);
        }
      }
      if (type === "Merchants") {
        const response = await fetchMerchand(page + 1, rowsPerPage, searchTerm);
        if (response && response.data) {
          const newData = response.data.data?.map((val) => {
            return {
              ...val,
              picture: val?.picture,
              phone: String(val?.phone).slice(0, 18),
            };
          });
          setData(newData);
          setTotalRecords(response.data.total);
        }
      }
      if (type === "All Agencies") {
        const response = await fetchAgencyList(
          page + 1,
          rowsPerPage,
          searchTerm
        );
        if (response && response.data) {
          const newData = response?.data?.data?.map((val) => {
            return {
              ...val,
              password: val?.password
                ? String(val?.password).slice(0, 18)
                : "N/A",
              phone: val?.phone ? String(val.phone).slice(0, 18) : "N/A",
            };
          });
          setData(newData);
          setTotalRecords(response.data.total || response.data?.data?.length);
        }
      }
    } catch (error) {
      console.error(`Failed to fetch ${type}:`, error);
    } finally {
      setLoading(false);
    }
  };

  const searchData = async () => {
    setLoading(true);
    if (type === "Active Users") {
      try {
        const response = await searchUser({ codes: searchTerm });
        if (response && response.data) {
          setData(response.data.data || response.data);
          setTotalRecords(response.data.total);
        }
      } catch (error) {
        console.error("Search failed:", error);
      } finally {
        setLoading(false);
      }
    }
  };

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleReset = () => {
    setValue([null, null]);
    setHistoryType("all");
    setSearchTerm("");
  };

  useEffect(() => {
    if (searchTerm.length > 0 && searchTerm[0].length == 8) {
      searchData();
    } else {
      fetchData();
    }
  }, [
    searchTerm,
    type,
    page,
    rowsPerPage,
    dataFromparent,
    formattedEnd,
    subType,
    historyType,
    donationtype,
    selectedType,
    familyStatus,
    currentCountry,
    filter,
    withdrawStatus,
    userProfile,
    formattedDate,
  ]);

  const handleDelete = async () => {
    if (selected.length === 0) return;
    setLoading(true);

    const deleteActions = {
      "Sub Admins": deleteAdmin,
      "Banned Users": updateUnBanUser,
      "Profile Tags": DeleteProfileTag,
      "Assign Profile Tags": DeleteProfileUserTag,
      "All Banners": DeleteBannerData,
      "Active Banners": DeleteBannerData,
      "Inactive Banners": DeleteBannerData,
      "Special RID": DeleteSpecialRid,
      Images: DeleteBannerImage,
      Families: deleteFamily,
      "Diamond Packages": deleteDiamondPackage,
      "Sending Level": deleteSenderLevel,
      "Hosting Level": deleteHostLevel,
      Permissions: deletePermision,
      "Product Categories": deleteCategory,
      "Scheduled PKs": deletePk,
      Gift: deleteGift,
      "Family Rule": deleteFamilyRule,
      "Live Stream Tags": deleteTag,
      "Assign Livestream Tag": deleteStreamTag,
      Products: deleteProducts,
      "All Agencies": deleteAgency,
      Merchants: deleteMerchant,
      "Withdraw Payment Methods": deleteWithdrawPayment,
      "All Svip": deleteSvip,
    };

    try {
      const deleteFn = deleteActions[type];

      if (deleteFn) {
        const idsToDelete =
          type === "Merchants"
            ? selected.map((id) => {
                const merchant = data.find((item) => item.id === id);
                return merchant?.userId;
              })
            : selected;
        const responses = await Promise.all(
          idsToDelete.map((id) => deleteFn(id))
        );

        // check if all succeeded
        const allOk = responses.every((res) => res?.status === 200);

        if (allOk) {
          setData(data.filter((item) => !selected.includes(item.id)));
          setSelected([]);
          enqueueSnackbar("Record deleted successfully!", {
            variant: "success",
          });
        } else {
          // find first failed response
          const failedResponse = responses.find((res) => res?.status !== 200);
          enqueueSnackbar(
            failedResponse?.message ||
              failedResponse?.error ||
              "Error while deleting some records",
            {
              variant: "error",
            }
          );
        }
      } else {
        enqueueSnackbar("Invalid delete action", {
          variant: "error",
        });
      }
    } catch (error) {
      enqueueSnackbar("Error occurred", { variant: "error" });
    } finally {
      setLoading(false);
      setOpenDialog(false);
    }
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelected = data.map((n) => n.id);
      setSelected(newSelected);
      return;
    }
    setSelected([]);
  };

  const handleDeleteIconClick = () => {
    setOpenDialog(true);
  };

  const NAvigateToPage = (id, name, description, tagName, sortOrder, row) => {
    if (type === "Sub Admins") {
      navigate(`/admin/detail/${id}`);
    }
    if (type === "Reseller") {
      navigate(`/add-reseller/${id}`);
    }
    if (type === "Withdraw Request") {
      navigate(`/single/withdraw/${id}`, { state: withdrawStatus });
    }
    if (type === "Family Rule") {
      navigate(`/create-family-rule/${id}`);
    }
    if (type === "Customer") {
      navigate(`/add-customer/${id}`);
    }
    if (type === "All Banners") {
      navigate(`/edit-banner/${id}`, { state: row });
    }
    if (type === "Profile Tags") {
      navigate(`/edit-profile-tag/${id}`, { state: row });
    }

    if (type === "Special RID") {
      navigate(`/edit-rid/${id}`);
    }
    if (type === "Images") {
      navigate(`/edit-image/${id}`);
    }
    if (type === "Merchants") {
      navigate(`/add-merchant/${id}`);
    }
    if (
      type === "All Moments" ||
      type == "Active Moments" ||
      type == "Pending Moments" ||
      type == "Rejected Moments"
    ) {
      setImagesData(row);
      setOpenImageModel(true);
    }
    if (type === "Diamond Packages") {
      navigate(`/edit-package/${id}`);
    }
    if (type === "Families") {
      navigate(`/edit-family/${id}`);
    }
    if (type === "Sending Level") {
      navigate(`/edit-sender-level`, { state: row });
    }
    if (type === "Hosting Level") {
      navigate(`/edit-host-level`, { state: row });
    }

    if (type === "Active Users") {
      navigate(`/user/detail/${id}`);
    }
    if (type === "AgencyUser") {
      navigate(`/user/detail/${id}`);
    }
    if (type === "Scheduled PKs") {
      navigate(`/updatePk/${id}`);
    }
    if (type === "Products") {
      navigate(`/products/edit-product/${id}`);
    }
    if (type === "Gift") {
      navigate(`/gift/${id}`);
    }
    if (type === "Permissions") {
      setModeltype("Update");
      setModelData({ name, id });
      setOpenAddPermisionDialog(true);
    }
    if (type === "All Agencies") {
      navigate(`/agency/detail/${id}`);
    }
    if (type === "Product Categories") {
      setModeltype("Update");
      setModelData({ name, id, description });
      setOpenAddCategoriesDialog(true);
    }
    if (type === "Live Stream Tags") {
      setModeltype("Update");
      setModelData({ tagName, id, sortOrder });
      setOpenAddTagDialog(true);
    }
  };

  const NavigateToAssign = (row) => {
    setModelData(row);
    setModeltype("Add");
    setOpenAssignTagModel(true);
  };

  const NavigateToUpdateLevel = (row) => {
    navigate("/update-level", { state: row });
  };
  const NavigateToUpdateHostLevel = (row) => {
    navigate("/update-host-level", { state: row });
  };

  const NavigateToAssignLevel = (row) => {
    navigate("/assign-level", { state: row });
  };
  const NavigateToAssignHostLevel = (row) => {
    navigate("/assign-host-level", { state: row });
  };
  const NavigateToAssignProfile = (row) => {
    setModelData(row);
    setModeltype("Add");
    setOpenAssignProfileTagModel(true);
  };
  const NavigateToAssignHostingLevel = (row) => {
    navigate("/assign-host-level", { state: row });
  };
  const NavigateToUpdateAssign = (row) => {
    setModelData(row);
    setModeltype("Update");
    setOpenAssignTagModel(true);
  };
  const NavigateToUpdateAssignTag = (row) => {
    setModelData(row);
    setModeltype("Update");
    setOpenAssignProfileTagModel(true);
  };
  const NavigateToAddPage = () => {
    if (type === "Deleted Users") {
      navigate("/add-deactive");
    }
    if (type === "Sub Admins") {
      navigate("/admins/create");
    }
    if (type === "All Banners") {
      navigate("/add-banner");
    }
    if (type === "Banned Users") {
      navigate("/ban-user");
    }
    if (type === "Profile Tags") {
      navigate("/add-profile-tag");
    }
    if (type === "Special RID") {
      navigate("/add-rid");
    }
    if (type === "Images") {
      navigate("/add-image");
    }
    if (type === "Diamond Packages") {
      navigate(`/add-package`);
    }
    if (type == "Bussiness-developers") {
      navigate("/add-bussiness-developer");
    }
    if (type == "Sending Level") {
      navigate("/add-sender-level");
    }
    if (type == "Hosting Level") {
      navigate("/add-host-level");
    }
    if (type == "Send Rcoins") {
      navigate("/send-coins");
    }

    if (type === "Scheduled PKs") {
      navigate("/setpk");
    }
    if (type === "Send Diamonds") {
      navigate("/diamond-list/add-diamond");
    }
    if (type === "Permissions") {
      setModeltype("Add");
      setOpenAddPermisionDialog(true);
    }
    if (type === "Product Categories") {
      setModeltype("Add");
      setOpenAddCategoriesDialog(true);
    }
    if (type === "Gift") {
      navigate("/createGift");
    }
    if (type === "Live Stream Tags") {
      setModeltype("Add");
      setOpenAddTagDialog(true);
    }
    if (type === "Products") {
      navigate("/products/add-product");
    }
    if (type === "All Agencies") {
      navigate("/agency/create");
    }
    if (type === "All Svip") {
      navigate("/svip/create");
    }
    if (type === "Withdraw Payment Methods") {
      navigate("/add-withdraw-list");
    }
    if (type === "Merchants") {
      navigate("/add-merchant");
    }
    if (type === "Customer") {
      navigate("/add-customer");
    }
    if (type === "Family Rule") {
      navigate("/create-family-rule");
    }
  };

  const handleClick = (id) => {
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }
    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const closeDialog = () => {
    fetchData();
    if (type === "Permissions") {
      setOpenAddPermisionDialog(false);
    }
    if (type === "Live Stream Tags") {
      setOpenAssignTagModel(false);
    }
    if (type === "Product Categories") {
      setOpenAddCategoriesDialog(false);
    }
    if (type === "Live Stream Tags") {
      setOpenAddTagDialog(false);
    }
  };

  const handleChangeVideoStatus = async (e, id) => {
    const value = e.target.value;
    if (value == "rejected") {
      setOpenReasonModel(true);
      setMomentId(id);
      return;
    }
    const data = {
      status: value,
      // rejectReason: "",
    };
    const resp = await updateMomentVideoStatus(id, data);
    if (resp.status == 200) {
      enqueueSnackbar(resp?.data?.message, { variant: "success" });
      fetchData();
    } else {
      enqueueSnackbar(
        resp?.message ||
          resp?.error ||
          resp?.data?.message ||
          resp?.data?.error,
        { variant: "error" }
      );
    }
  };
  const handleProfileeStatus = async (e, id) => {
    const value = e.target.value;

    const resp = await updateUSerProfileStatus(id, value);
    if (resp.status == 200) {
      enqueueSnackbar(resp?.data?.message, { variant: "success" });
      fetchData();
    } else {
      enqueueSnackbar(resp?.message, { variant: "error" });
    }
  };
  const handleChangeStatus = async (e, id) => {
    const value = e.target.value;

    if (value == "rejected") {
      setOpenReasonModel(true);
      setMomentId(id);
      return;
    }
    const data = {
      status: value,
      rejectReason: "",
    };
    const resp = await updateMomentStatus(id, data);
    if (resp.status == 200) {
      enqueueSnackbar(resp?.data?.message, { variant: "success" });
      fetchData();
    } else {
      enqueueSnackbar(resp?.message, { variant: "error" });
    }
  };
  const handleChangeStatus1 = async (e, id) => {
    const value = e.target.value;
    if (value == "Blocked") {
      setOpenReasonModel(true);
      setMomentId(id);
      return;
    }
    const payload = {
      status: value,
    };
    if (type == "Reseller") {
      const resp = await UpdateResellerStatus(id, payload);
      if (resp?.status == 200) {
        enqueueSnackbar(resp?.data?.message, { variant: "success" });
        fetchData();
      } else {
        enqueueSnackbar(
          resp?.message ||
            resp?.data?.message ||
            resp?.error ||
            resp?.data?.error,
          { variant: "error" }
        );
      }
    } else {
      const data = {
        status: value,
      };
      const resp = await updateFamilyStatus(id, data);
      if (resp.status == 200) {
        enqueueSnackbar(resp?.data?.message, { variant: "success" });
        fetchData();
      } else {
        enqueueSnackbar(resp?.message, { variant: "error" });
      }
    }
  };
  const handleChangeStatusAgency = async (e, id, level) => {
    const statusValue = e.target.value.toLowerCase();

    let payload = {};
    if (statusValue === "reject") {
      payload = { status: statusValue };
    } else {
      payload = {
        status: statusValue,
        level: level,
      };
    }
    const resp = await UpdateAgencyStatus(id, payload);
    if (resp?.status == 200) {
      enqueueSnackbar(resp?.data?.message, { variant: "success" });
      fetchData();
    } else {
      enqueueSnackbar(
        resp?.message ||
          resp?.error ||
          resp?.data?.message ||
          resp?.data?.error ||
          "Try Later",
        { variant: "error" }
      );
    }
  };
  const handleChangeStatusBanner = async (e, id) => {
    const value = e.target.value;

    const payload = {
      status: value,
    };
    if (type === "Customer") {
      const resp = await UpdateCustomerStatusApi(id, payload);
      if (resp?.status == 200) {
        enqueueSnackbar(resp?.data?.message, { variant: "success" });
        fetchData();
      } else {
        enqueueSnackbar(
          resp?.message ||
            resp?.data?.message ||
            resp?.error ||
            resp?.data?.message,
          { variant: "error" }
        );
      }
      return;
    }
    const resp = await UpdateBannerStatusApi(id);
    if (resp?.status == 200) {
      enqueueSnackbar(resp?.data?.message, { variant: "success" });
      fetchData();
    } else {
      enqueueSnackbar(resp?.error, { variant: "error" });
    }
  };
  const handleStatus = async (e, id) => {
    const value = e.target.value;
    const data = {
      status: value,
    };
    const resp = await updateMerchantStatus(id, data);
    if (resp.status == 200) {
      enqueueSnackbar(resp?.data?.message, { variant: "success" });
      fetchData();
    } else {
      enqueueSnackbar(resp?.message, { variant: "error" });
    }
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!Reason) {
      return;
      enqueueSnackbar("Reason field is required", { variant: "error" });
    }
    if (type == "Families") {
      const data = {
        status: "Blocked",
        blockedReason: Reason,
      };
      const resp = await updateFamilyStatus(MomentId, data);
      if (resp.status == 200) {
        enqueueSnackbar(resp?.data?.message, { variant: "success" });
        setOpenReasonModel(false);
        fetchData();
      } else {
        enqueueSnackbar(resp?.message, { variant: "error" });
      }
    } else if (type == "Reseller") {
      const payload = {
        status: "Blocked",
      };
      const resp = await UpdateResellerStatus(MomentId, payload);
      if (resp?.status == 200) {
        enqueueSnackbar(resp?.data?.message, { variant: "success" });
        setOpenReasonModel(false);
        fetchData();
      } else {
        enqueueSnackbar(
          resp?.message ||
            resp?.data?.message ||
            resp?.error ||
            resp?.data?.error,
          { variant: "error" }
        );
      }
    } else {
      if (
        type == "Active Moments" ||
        type == "Pending Moments" ||
        type == "Rejected Moments"
      ) {
        const data = {
          status: "rejected",
          rejectReason: Reason,
        };
        const resp = await updateMomentStatus(MomentId, data);
        if (resp.status == 200) {
          enqueueSnackbar(resp?.data?.message, { variant: "success" });
          setOpenReasonModel(false);
          fetchData();
        } else {
          enqueueSnackbar(resp?.data?.message, { variant: "error" });
          setOpenReasonModel(false);
        }
      } else {
        const data = {
          status: "rejected",
          reason: Reason,
        };
        const resp = await updateMomentVideoStatus(MomentId, data);
        if (resp.status == 200) {
          enqueueSnackbar(resp?.data?.message, { variant: "success" });
          setOpenReasonModel(false);
          fetchData();
        } else {
          enqueueSnackbar(resp?.data?.message, { variant: "error" });
          setOpenReasonModel(false);
        }
      }
    }
  };

  const isSelected = (id) => selected.indexOf(id) !== -1;

  const { theme } = useDarkTheme();

  const renderRow = (row) => {
    return headCells.map((headCell) => {
      const getNestedValue = (obj, path) => {
        return (
          path.split(".").reduce((acc, part) => acc && acc[part], obj) ?? "N/A"
        );
      };

      if (headCell.id == "banned") {
        return (
          <>
            <TableCell key={headCell.id} align="left">
              <Chip
                label={row.banned == false ? "Active" : "Banned"}
                color={row.banned == false ? "success" : "error"}
                sx={{ height: "25px" }}
              />
            </TableCell>
          </>
        );
      }
      if (headCell.id == "giftType") {
        return (
          <>
            <TableCell key={headCell.id} align="left">
              <Chip
                label={row.gift.type}
                sx={{
                  backgroundColor:
                    row.gift.type === "Lucky" ? "#8F29D0" : "#6467DA",
                  color: "#fff",
                  height: "25px",
                }}
              />
            </TableCell>
          </>
        );
      }
      if (row.status !== "active") {
        if (headCell.id == "profileuser") {
          return (
            <>
              {row?.status === "pending" ? (
                <TableCell>
                  <FormControl fullWidth size="small">
                    <InputLabel id="demo-simple-select-label">
                      Status
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={row.status}
                      label="Status"
                      onChange={(e) => handleProfileeStatus(e, row?.id)}
                    >
                      <MenuItem value={"pending"}>Pending</MenuItem>
                      <MenuItem value={"approved"}>Active</MenuItem>
                      <MenuItem value={"rejected"}>Rejected</MenuItem>
                    </Select>
                  </FormControl>
                </TableCell>
              ) : row?.status === "approved" ? (
                <TableCell>
                  <FormControl fullWidth size="small">
                    <InputLabel id="demo-simple-select-label">
                      Status
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={row.status}
                      label="Status"
                      onChange={(e) => handleProfileeStatus(e, row?.id)}
                    >
                      <MenuItem value={"approved"}>Active</MenuItem>
                    </Select>
                  </FormControl>
                </TableCell>
              ) : row?.status === "rejected" ? (
                <TableCell>
                  <FormControl fullWidth size="small">
                    <InputLabel id="demo-simple-select-label">
                      Status
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={row.status}
                      label="Status"
                      onChange={(e) => handleProfileeStatus(e, row?.id)}
                    >
                      <MenuItem value={"rejected"}>Rejected</MenuItem>
                    </Select>
                  </FormControl>
                </TableCell>
              ) : (
                <></>
              )}
            </>
          );
        }
        if (headCell.id == "dropdown") {
          return (
            <>
              <TableCell>
                <FormControl fullWidth size="small">
                  <InputLabel id="demo-simple-select-label">Status</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={row.status}
                    label="Status"
                    onChange={(e) => handleChangeStatus(e, row?.id)}
                  >
                    <MenuItem value={"pending"}>Pending</MenuItem>
                    <MenuItem value={"active"}>Active</MenuItem>
                    <MenuItem value={"rejected"}>Rejected</MenuItem>
                  </Select>
                </FormControl>
              </TableCell>
            </>
          );
        }
        if (headCell.id == "dropdown1") {
          return (
            <>
              <TableCell>
                <FormControl fullWidth size="small">
                  <InputLabel id="demo-simple-select-label">Status</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={row.status}
                    label="Status"
                    onChange={(e) =>
                      type == "Merchants"
                        ? handleStatus(e, row?.id)
                        : handleChangeStatus1(e, row?.id)
                    }
                  >
                    <MenuItem value={"Pending"}>Pending</MenuItem>
                    <MenuItem value={"Active"}>Active</MenuItem>
                    <MenuItem value={"Blocked"}>Blocked</MenuItem>
                  </Select>
                </FormControl>
              </TableCell>
            </>
          );
        }
        if (headCell.id == "dropdown2") {
          return (
            <>
              <TableCell>
                <FormControl fullWidth size="small">
                  <InputLabel id="demo-simple-select-label">Status</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={row.approvalStatus}
                    label="Status"
                    onChange={(e) => handleChangeVideoStatus(e, row?.id)}
                  >
                    <MenuItem value={"pending"}>Pending</MenuItem>
                    <MenuItem value={"approved"}>Active</MenuItem>
                    <MenuItem value={"rejected"}>Rejected</MenuItem>
                  </Select>
                </FormControl>
              </TableCell>
            </>
          );
        }
        if (headCell.id == "isActive") {
          return (
            <>
              <TableCell>
                <FormControl fullWidth size="small">
                  <InputLabel id="demo-simple-select-label">Status</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={row.isActive || row.banned}
                    label="Status"
                    onChange={(e) => handleChangeStatusBanner(e, row?.id)}
                  >
                    <MenuItem value={true}>Active</MenuItem>
                    <MenuItem value={false}>Inactive</MenuItem>
                  </Select>
                </FormControl>
              </TableCell>
            </>
          );
        }
        if (headCell.id == "isActive1") {
          return (
            <>
              <TableCell>
                <Box
                  sx={{ display: "flex", flexDirection: "column", gap: "10px" }}
                >
                  <TextField
                    label="Enter Level"
                    sx={{ width: "100px" }}
                    value={levelInputs[row.id] || ""}
                    onChange={(e) =>
                      setLevelInputs({
                        ...levelInputs,
                        [row.id]: e.target.value,
                      })
                    }
                  />
                  <FormControl fullWidth size="small">
                    <InputLabel id="demo-simple-select-label">
                      Status
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={row.status}
                      label="Status"
                      onChange={(e) =>
                        handleChangeStatusAgency(
                          e,
                          row?.id,
                          levelInputs[row.id] || ""
                        )
                      }
                    >
                      <MenuItem value={"Pending"}>Pending</MenuItem>
                      <MenuItem value={"active"}>Active</MenuItem>
                      <MenuItem value={"reject"}>Reject</MenuItem>
                    </Select>
                  </FormControl>
                </Box>
              </TableCell>
            </>
          );
        }
      }

      if (headCell.id == "status") {
        return (
          <>
            <TableCell>
              <Chip
                label={row?.status}
                color={
                  row?.status == "active"
                    ? "success"
                    : row.status == "pending"
                    ? "primary"
                    : "error"
                }
                sx={{ height: "23px" }}
              />
            </TableCell>
          </>
        );
      }

      if (headCell.id == "tagstatus") {
        return (
          <>
            <TableCell>
              <Chip
                label={row?.status == true ? "Active" : "InActive"}
                color={row?.status == true ? "success" : "error"}
                sx={{ height: "23px" }}
              />
            </TableCell>
          </>
        );
      }

      if (headCell.id == "ridStatus") {
        return (
          <>
            <TableCell>{row?.status}</TableCell>
          </>
        );
      }
      if (headCell.id == "isExpired") {
        return (
          <>
            <TableCell>
              <Chip
                label={row?.isExpired == false ? "False" : "True"}
                color={row?.isExpired == true ? "success" : "error"}
                sx={{ height: "23px" }}
              />
            </TableCell>
          </>
        );
      }
      if (headCell.id == "MiniProfile") {
        return (
          <>
            <TableCell>
              <Chip
                label={row?.miniProfileColorful == false ? "False" : "True"}
                color={row?.miniProfileColorful == true ? "success" : "error"}
                sx={{ height: "23px" }}
              />
            </TableCell>
          </>
        );
      }
      if (headCell.id == "canLive") {
        return (
          <>
            <TableCell>
              <Chip
                label={row?.canLive == false ? "False" : "True"}
                color={row?.canLive == true ? "success" : "error"}
                sx={{ height: "23px" }}
              />
            </TableCell>
          </>
        );
      }
      if (headCell.id == "canMute") {
        return (
          <>
            <TableCell>
              <Chip
                label={row?.canMute == false ? "False" : "True"}
                color={row?.canMute == true ? "success" : "error"}
                sx={{ height: "23px" }}
              />
            </TableCell>
          </>
        );
      }
      if (headCell.id == "canKick") {
        return (
          <>
            <TableCell>
              <Chip
                label={row?.canKick == false ? "False" : "True"}
                color={row?.canKick == false ? "error" : "success"}
                sx={{ height: "23px" }}
              />
            </TableCell>
          </>
        );
      }
      if (headCell.id == "agencyStatus") {
        return (
          <>
            <TableCell>
              <Chip
                label={row?.status}
                color={
                  row?.status == "Active"
                    ? "success"
                    : row.status == "Pending"
                    ? "primary"
                    : "error"
                }
                sx={{ height: "23px" }}
              />
            </TableCell>
          </>
        );
      }

      if (headCell.id === "action") {
        return (
          <>
            {type === "Assign Livestream Tag" ||
            type === "Assign Profile Tags" ||
            type === "Assign Sending Level" ||
            type === "Withdraw Request" ||
            type === "Banned Users" ||
            type === "Deleted Users" ||
            type === "Active Users" ||
            type === "Assign Hosting Level" ? (
              ""
            ) : (
              <TableCell
                key={headCell.id}
                align="left"
                style={{ cursor: "pointer", textDecoration: "underline" }}
                onClick={() =>
                  NAvigateToPage(
                    row.id,
                    row.name,
                    row?.description,
                    row?.tagName,
                    row?.sortOrder,
                    row
                  )
                }
              >
                Update
              </TableCell>
            )}
            {type === "Banned Users" && (
              <TableCell
                key={headCell.id}
                align="left"
                style={{ cursor: "pointer", textDecoration: "underline" }}
                onClick={() => handleUnban(row.user.code)}
              >
                <Button variant="contained" className="gradientButton">
                  Unban
                </Button>
              </TableCell>
            )}
            {type === "Deleted Users" && (
              <TableCell
                key={headCell.id}
                align="left"
                style={{ cursor: "pointer", textDecoration: "underline" }}
                onClick={() => handleReactive(row.id)}
              >
                <Button variant="contained" className="gradientButton">
                  ReActive
                </Button>
              </TableCell>
            )}
            {type === "Withdraw Request" ||
              (type === "Active Users" && (
                <TableCell
                  key={headCell.id}
                  align="left"
                  style={{ cursor: "pointer", textDecoration: "underline" }}
                  onClick={() => NAvigateToPage(row.id, row.status)}
                >
                  Detail
                </TableCell>
              ))}
            {type === "Live Stream Tags" && (
              <TableCell
                key={headCell.id}
                align="left"
                style={{ cursor: "pointer", textDecoration: "underline" }}
                onClick={() => NavigateToAssign(row)}
              >
                Assign Tag
              </TableCell>
            )}
            {type === "Sending Level" && (
              <TableCell
                key={headCell.id}
                align="left"
                style={{ cursor: "pointer", textDecoration: "underline" }}
                onClick={() => NavigateToAssignLevel(row)}
              >
                Assign Level
              </TableCell>
            )}
            {type === "Hosting Level" && (
              <TableCell
                key={headCell.id}
                align="left"
                style={{ cursor: "pointer", textDecoration: "underline" }}
                onClick={() => NavigateToAssignHostingLevel(row)}
              >
                Assign Level
              </TableCell>
            )}
            {type === "Host Level" && (
              <TableCell
                key={headCell.id}
                align="left"
                style={{ cursor: "pointer", textDecoration: "underline" }}
                onClick={() => NavigateToAssignHostLevel(row)}
              >
                Assign Level
              </TableCell>
            )}
            {type === "Profile Tags" && (
              <TableCell
                key={headCell.id}
                align="left"
                style={{ cursor: "pointer", textDecoration: "underline" }}
                onClick={() => NavigateToAssignProfile(row)}
              >
                Assign Tag
              </TableCell>
            )}
            {type === "Assign Livestream Tag" && (
              <TableCell
                key={headCell.id}
                align="left"
                style={{ cursor: "pointer", textDecoration: "underline" }}
                onClick={() => NavigateToUpdateAssign(row)}
              >
                Update Tag
              </TableCell>
            )}
            {type === "Assign Sending Level" && (
              <TableCell
                key={headCell.id}
                align="left"
                style={{ cursor: "pointer", textDecoration: "underline" }}
                onClick={() => NavigateToUpdateLevel(row)}
              >
                Update Level
              </TableCell>
            )}
            {type === "Assign Hosting Level" && (
              <TableCell
                key={headCell.id}
                align="left"
                style={{ cursor: "pointer", textDecoration: "underline" }}
                onClick={() => NavigateToUpdateHostLevel(row)}
              >
                Update Level
              </TableCell>
            )}
            {type === "Assign Profile Tags" && (
              <TableCell
                key={headCell.id}
                align="left"
                style={{ cursor: "pointer", textDecoration: "underline" }}
                onClick={() => NavigateToUpdateAssignTag(row)}
              >
                Update Tag
              </TableCell>
            )}
          </>
        );
      }

      if (headCell.id === "pictureUrl") {
        const imageUrl = row.pictureUrl?.startsWith("http")
          ? row.pictureUrl
          : `${fileUrl}${row.pictureUrl}`;

        return (
          <>
            <TableCell
              key={headCell.id}
              align="left"
              style={{ cursor: "pointer", textDecoration: "underline" }}
              onClick={() =>
                NAvigateToPage(
                  row.id,
                  row.name,
                  row?.description,
                  row?.tagName,
                  row?.sortOrder,
                  row,
                  imageUrl
                )
              }
            >
              <Avatar
                src={imageUrl}
                style={{ width: "70px", height: "70px", objectFit: "contain" }}
                alt=""
              />
            </TableCell>
          </>
        );
      }
      if (headCell.id === "photoUrl") {
        const imageUrl = row.pictureUrl?.startsWith("http")
          ? row.pictureUrl
          : `${fileUrl}${row.pictureUrl}`;

        return (
          <>
            <TableCell
              key={headCell.id}
              align="left"
              style={{ cursor: "pointer", textDecoration: "underline" }}
              onClick={() =>
                NAvigateToPage(
                  row.id,
                  row.name,
                  row?.description,
                  row?.tagName,
                  row?.sortOrder,
                  row,
                  imageUrl
                )
              }
            >
              <Avatar
                src={imageUrl}
                style={{ width: "70px", height: "70px", objectFit: "contain" }}
                alt=""
              />
            </TableCell>
          </>
        );
      }

      if (headCell.id === "imageUrl1") {
        const imageArray = Array.isArray(row.pictureUrl) ? row.pictureUrl : [];
        const firstImage = imageArray[0]
          ? imageArray[0]?.startsWith("http")
            ? imageArray[0]
            : `${fileUrl}${imageArray[0]}`
          : "";

        return (
          <TableCell key={headCell.id} align="left">
            <div style={{ display: "flex", alignItems: "center" }}>
              {/* {firstImage && ( */}
              <Avatar
                src={firstImage}
                style={{
                  width: "70px",
                  height: "70px",
                  objectFit: "contain",
                  cursor: "pointer",
                }}
                alt=""
                onClick={() =>
                  NAvigateToPage(
                    row.id,
                    row.name,
                    row?.description,
                    row?.tagName,
                    row?.sortOrder,
                    row,
                    firstImage
                  )
                }
              />
              {/* )} */}
            </div>
          </TableCell>
        );
      }

      if (headCell.id === "animationUrl") {
        const isValidUrl =
          row.animationUrl && typeof row.animationUrl === "string";

        const animationUrl = isValidUrl
          ? row.animationUrl?.startsWith("http")
            ? row.animationUrl
            : `${fileUrl}${row.animationUrl}`
          : null;

        return (
          <TableCell key={headCell.id} align="left">
            {animationUrl ? (
              <SVGAAnimation animationUrl={animationUrl} />
            ) : (
              <Typography variant="body2" color="text.secondary">
                No animation
              </Typography>
            )}
          </TableCell>
        );
      }
      if (headCell.id === "videoUrl") {
        if (row?.videoUrl === "audio") {
          return (
            <TableCell key={headCell.id} align="left">
              audio
            </TableCell>
          );
        } else {
          const imageUrl = row?.videoUrl?.startsWith("http")
            ? row?.videoUrl
            : videoURL + row?.videoUrl;

          const thumbnail = row?.thumbnail?.startsWith("http")
            ? row?.thumbnail
            : videoURL + row?.thumbnail;

          return (
            <TableCell
              key={headCell.id}
              align="left"
              style={{ cursor: "pointer", textDecoration: "underline" }}
            >
              <video
                src={imageUrl}
                poster={thumbnail}
                style={{ width: "150px", height: "150px" }}
                controls
              />
            </TableCell>
          );
        }
      }
      if (headCell.id === "pictureUrl") {
        const imageUrl = row?.pictureUrl?.startsWith("http")
          ? row.pictureUrl
          : `${fileUrl}${row?.pictureUrl}`;

        return (
          <TableCell
            key={headCell.id}
            align="left"
            style={{ cursor: "pointer", textDecoration: "underline" }}
          >
            <Avatar
              src={imageUrl}
              alt=""
              style={{ width: "70px", height: "70px" }}
            />
          </TableCell>
        );
      }
      if (headCell.id === "picture") {
        const imageUrl = row?.picture?.startsWith("https")
          ? row?.picture
          : `${fileUrl}${row?.picture}`;
        return (
          <TableCell
            key={headCell.id}
            align="left"
            style={{ cursor: "pointer", textDecoration: "underline" }}
          >
            <Avatar
              src={imageUrl}
              alt=""
              style={{ width: "70px", height: "70px" }}
            />
          </TableCell>
        );
      }
      if (headCell.id === "url") {
        const imageUrl = fileUrl + row?.url;
        return (
          <TableCell
            key={headCell.id}
            align="left"
            style={{ cursor: "pointer", textDecoration: "underline" }}
          >
            <Avatar
              src={imageUrl}
              alt=""
              style={{ width: "70px", height: "70px" }}
            />
          </TableCell>
        );
      }
      if (headCell.id === "assignUserImage") {
        const imageUrl = row?.assignUserImage?.startsWith("https")
          ? row?.assignUserImage
          : `${fileUrl}${row?.assignUserImage}`;
        return (
          <TableCell
            key={headCell.id}
            align="left"
            style={{ cursor: "pointer", textDecoration: "underline" }}
          >
            <Avatar
              src={imageUrl}
              alt=""
              style={{ width: "70px", height: "70px" }}
            />
          </TableCell>
        );
      }
      if (headCell.id === "adminImage") {
        const imageUrl = row?.adminImage?.startsWith("https")
          ? row?.adminImage
          : `${fileUrl}${row?.adminImage}`;
        return (
          <TableCell
            key={headCell.id}
            align="left"
            style={{ cursor: "pointer", textDecoration: "underline" }}
          >
            <Avatar
              src={imageUrl}
              alt=""
              style={{ width: "70px", height: "70px" }}
            />
          </TableCell>
        );
      }
      if (headCell.id === "tagImage") {
        const imageUrl = row?.tagImage?.startsWith("https")
          ? row?.tagImage
          : `${fileUrl}${row?.tagImage}`;
        return (
          <TableCell
            key={headCell.id}
            align="left"
            style={{ cursor: "pointer", textDecoration: "underline" }}
          >
            <Avatar
              src={imageUrl}
              alt=""
              style={{ width: "70px", height: "70px" }}
            />
          </TableCell>
        );
      }
      if (headCell.id === "isInternalLink") {
        return (
          <TableCell
            key={headCell.id}
            align="left"
            style={{ cursor: "pointer", textDecoration: "underline" }}
          >
            <Chip
              label={row?.isInternalLink === true ? "True" : "False"}
              color={row?.isInternalLink === true ? "success" : "error"}
            />
          </TableCell>
        );
      }
      if (headCell.id === "animationsurl") {
        const imageUrl = row?.animationsurl?.startsWith("https")
          ? row?.animationsurl
          : `${fileUrl}${row?.animationsurl}`;
        return (
          <TableCell key={headCell.id} align="left">
            <SVGAAnimation animationUrl={imageUrl} />
          </TableCell>
        );
      }

      if (
        headCell.id === "picture" ||
        headCell.id === "opponentTwoUser.picture"
      ) {
        return (
          <TableCell key={headCell.id} align="left">
            <Avatar alt={row.name} src={row?.picture2} />
          </TableCell>
        );
      }
      if (
        headCell.id === "picture" ||
        headCell.id === "opponentOneUser.picture"
      ) {
        return (
          <TableCell key={headCell.id} align="left">
            <Avatar alt={row.name} src={row?.picture1} />
          </TableCell>
        );
      }
      const cellValue = getNestedValue(row, headCell.id);
      return (
        <TableCell
          key={headCell.id}
          align={headCell.numeric ? "right" : "left"}
        >
          {headCell.id === "created" ||
          headCell.id === "createdAt" ||
          headCell.id === "pkDat"
            ? formatDate(cellValue)
            : cellValue}
        </TableCell>
      );
    });
  };

  const labelStyles = {
    color: "",
    "&.Mui-focused": {
      color: "#8F29D0",
    },
  };
  const tableUI = (
    <ThemeProvider theme={theme}>
      <Box sx={{ width: "100%" }}>
        <Paper sx={{ width: "100%", maxHeight: "95vh" }}>
          <Toolbar sx={{ display: "flex", justifyContent: "space-between" }}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                width: "100%",
              }}
            >
              {selected.length > 0 ? (
                <Tooltip title="Delete">
                  <IconButton onClick={handleDeleteIconClick}>
                    <DeleteIcon />
                  </IconButton>
                </Tooltip>
              ) : (
                <>
                  <Typography
                    variant="h5"
                    id="tabletype"
                    component="div"
                    fontWeight={600}
                  >
                    {type}{" "}
                    {type === "Send Rcoins" || type === "Send Diamonds"
                      ? "History"
                      : "List"}
                  </Typography>
                  <Box
                    sx={{ display: "flex", alignItems: "center", gap: "10px" }}
                  >
                    {type !== "Active Users" &&
                      type !== "AgencyUser" &&
                      type !== "All Moments" &&
                      type !== "Pending Moments" &&
                      type !== "Active Moments" &&
                      type !== "Rejected Moments" &&
                      type !== "Active Video Moments" &&
                      type !== "Pending Video Moments" &&
                      type !== "Rejected Video Moments" &&
                      type !== "Families" &&
                      type !== "Assign Livestream Tag" &&
                      type !== "Assign Profile Tags" &&
                      type !== "Assign Sending Level" &&
                      type !== "Assign Hosting Level" &&
                      type !== "Join Agency Requests" &&
                      type !== "Inactive Banners" &&
                      type !== "Active Banners" &&
                      type !== "Gifts Sent & Receive History" &&
                      type !== "LiveStreams" &&
                      type !== "Reseller" &&
                      type !== "Donation Log" &&
                      type !== "Wallet Transaction" &&
                      type !== "Host" &&
                      type !== "Gifter Ranking" &&
                      type !== "User Report" &&
                      type !== "Withdraw Request" &&
                      type !== "Reported Moments" &&
                      type !== "Withdrawals Report" &&
                      type !== "Family Report" &&
                      type !== "Deleted Users" &&
                      type !== "Profile Users" &&
                      type !== "Gift Rank" && (
                        <Button
                          sx={{
                            background:
                              "linear-gradient(to right, #8832d1, #11c8d8)",
                            color: "white",
                            borderRadius: "6px",
                            textTransform: "none",
                          }}
                          onClick={NavigateToAddPage}
                        >
                          {type === "Send Rcoins" ||
                          type === "Send Diamonds" ||
                          type === "Scheduled PKs"
                            ? ""
                            : "Add"}{" "}
                          {type === "Live Stream Tags"
                            ? "Live Stream Tag"
                            : type === "Product Categories"
                            ? "Category"
                            : type === "Products"
                            ? "Product"
                            : type === "Sub Admins"
                            ? "Sub Admin"
                            : type === "Permissions"
                            ? "Permission"
                            : type === "Send Rcoins"
                            ? "Send Rcoin"
                            : type === "Diamond Packages"
                            ? "Diamond Package"
                            : type === "Images"
                            ? "Image"
                            : type === "Gift"
                            ? "New Gift"
                            : type === "Profile Tags"
                            ? "Profile Tag"
                            : type}
                        </Button>
                      )}
                  </Box>
                </>
              )}
            </Box>
          </Toolbar>
          <Toolbar
            sx={{
              display: "flex",
              gap: "10px",
              justifyContent: "space-between",
            }}
          >
            {type !== "Donation Log" &&
              type !== "Wallet Transaction" &&
              type !== "Gifter Ranking" &&
              type !== "Host" &&
              type !== "Scheduled PKs" &&
              type !== "Families" &&
              type !== "Profile Tags" &&
              type !== "Assign Profile Tags" &&
              type !== "Live Stream Tags" &&
              type !== "Assign Livestream Tag" &&
              type !== "Sending Level" &&
              type !== "Assign Sending Level" &&
              type !== "Hosting Level" &&
              type !== "Images" &&
              type !== "All Banners" &&
              type !== "Inactive Banners" &&
              type !== "Active Banners" &&
              type !== "Gift" &&
              type !== "Product Categories" &&
              type !== "Products" &&
              type !== "All Svip" &&
              type !== "Diamond Packages" &&
              type !== "Withdraw Payment Methods" &&
              type !== "Withdraw Requests" &&
              type !== "LiveStreams" &&
              type !== "Profile Users" &&
              type !== "Permissions" && (
                <Box
                  sx={{ display: "flex", gap: "10px", alignItems: "center" }}
                >
                  <TextField
                    label="RID Search"
                    variant="outlined"
                    size="small"
                    value={searchTerm}
                    onChange={(e) => handleSearch(e)}
                    InputLabelProps={{ sx: labelStyles }}
                  />
                </Box>
              )}
            {(type === "Host" || type === "Gift Rank") && (
              <>
                <CountryDropdown onSelect={handleCountryChange} />
                <Box width={200}>
                  <FormControl fullWidth>
                    <InputLabel id="type-label">Status</InputLabel>
                    <Select
                      labelId="type-label"
                      id="type-select"
                      value={filter}
                      label="Type"
                      onChange={handleChangeDate}
                      size="small"
                    >
                      <MenuItem value="today">Today</MenuItem>
                      <MenuItem value="weekly">Weekly</MenuItem>
                      <MenuItem value="monthly">Monthly</MenuItem>
                    </Select>
                  </FormControl>
                </Box>
              </>
            )}
            {type === "Withdraw Request" && (
              <FormControl fullWidth size="small" sx={{ width: 200 }}>
                <InputLabel>Withdraw Status</InputLabel>
                <Select
                  value={withdrawStatus}
                  label="Withdraw Status"
                  onChange={(e) => setWithdrawStatus(e.target.value)}
                >
                  {statuses.map((status) => (
                    <MenuItem key={status} value={status}>
                      {status}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            )}
            {(type === "Donation Log" ||
              type === "Wallet Transaction" ||
              type === "Gifter Ranking") && (
              <>
                <Box
                  sx={{ display: "flex", gap: "10px", alignItems: "center" }}
                >
                  <TextField
                    label="RID"
                    size="small"
                    value={rid}
                    onChange={(e) => setRid(e.target.value)}
                    variant="outlined"
                  />
                  <Button className="gradientButton" onClick={handleSubmitRID}>
                    Submit
                  </Button>
                </Box>
              </>
            )}
            {type === "Profile Users" && (
              <Box width={200}>
                <FormControl fullWidth>
                  <InputLabel id="status-label">Status</InputLabel>
                  <Select
                    labelId="status-label"
                    id="status-select"
                    value={userProfile}
                    input={<OutlinedInput label="Status" />}
                    onChange={handleChangeStatusUser}
                    size="small"
                  >
                    <MenuItem value="pending">Pending</MenuItem>
                    <MenuItem value="approved">Approved</MenuItem>
                    <MenuItem value="rejected">Rejected</MenuItem>
                  </Select>
                </FormControl>
              </Box>
            )}
            {type === "Families" && (
              <Box width={200}>
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">Status</InputLabel>
                  <Select
                    labelId="status-label"
                    id="status-select"
                    value={familyStatus}
                    input={<OutlinedInput label="Status" />}
                    onChange={handleChangeStatusFamilies}
                    size="small"
                  >
                    <MenuItem value="Pending">Pending</MenuItem>
                    <MenuItem value="Active">Approve</MenuItem>
                    <MenuItem value="Blocked">Blocked</MenuItem>
                  </Select>
                </FormControl>
              </Box>
            )}
            {type === "Send Diamonds" && (
              <Box width={200}>
                <FormControl fullWidth>
                  <InputLabel id="type-label">Type</InputLabel>
                  <Select
                    labelId="type-label"
                    id="type-select"
                    value={historyType}
                    label="Type"
                    onChange={handleChange}
                    size="small"
                  >
                    <MenuItem value="all">All</MenuItem>
                    <MenuItem value="sender">Sender</MenuItem>
                    <MenuItem value="reciever">Receiver</MenuItem>
                  </Select>
                </FormControl>
              </Box>
            )}
            {type === "Gifter Ranking" && (
              <Box width={200}>
                <FormControl fullWidth>
                  <InputLabel id="type-label">Value</InputLabel>
                  <Select
                    labelId="type-label"
                    id="type-select"
                    value={gifterRanking}
                    label="Type"
                    onChange={handleChangeGifterHistory}
                    size="small"
                  >
                    <MenuItem value="host">Host</MenuItem>
                    <MenuItem value="gifter">Gifter</MenuItem>
                  </Select>
                </FormControl>
              </Box>
            )}

            {type === "Donation Log" && (
              <Box width={200}>
                <FormControl fullWidth>
                  <InputLabel id="type-label">Type</InputLabel>
                  <Select
                    labelId="type-label"
                    id="type-select"
                    value={subType}
                    label="Type"
                    onChange={handleChangeSubType}
                    size="small"
                  >
                    <MenuItem value="audio">Audio</MenuItem>
                    <MenuItem value="video">Video</MenuItem>
                    <MenuItem value="offline">Offline</MenuItem>
                  </Select>
                </FormControl>
              </Box>
            )}
            {(type === "Donation Log" || type === "Wallet Transaction") && (
              <Box width={200}>
                <FormControl fullWidth>
                  <InputLabel id="type-label">Type</InputLabel>
                  <Select
                    labelId="type-label"
                    id="type-select"
                    value={donationtype}
                    label="Type"
                    onChange={handleChangeDonationType}
                    size="small"
                  >
                    <MenuItem value="sent">Sent</MenuItem>
                    <MenuItem value="recieved">Recieved</MenuItem>
                  </Select>
                </FormControl>
              </Box>
            )}
            {type === "Wallet Transaction" && (
              <Box width={200}>
                <FormControl fullWidth size="small">
                  <InputLabel>Transaction Type</InputLabel>
                  <Select
                    value={selectedType}
                    label="Transaction Type"
                    onChange={handleChangeTransaction}
                  >
                    {transactionTypes.map((type, index) => (
                      <MenuItem key={index} value={type}>
                        {type}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Box>
            )}
            {type === "Scheduled PKs" && (
              <DatePicker
                selected={startDate}
                onChange={handleChangeDatePK}
                dateFormat="yyyy-MM-dd"
              />
            )}
            {(type === "Send Diamonds" ||
              type === "Send Rcoins" ||
              type === "Donation Log" ||
              type === "Wallet Transaction") && (
              <Box>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DateRangePicker
                    startText="Start"
                    endText="End"
                    value={value}
                    onChange={(newValue) => setValue(newValue)}
                    slotProps={{
                      textField: {
                        size: "small",
                        fullWidth: true,
                      },
                    }}
                    renderInput={(startProps, endProps) => (
                      <Box sx={{ display: "flex", gap: 2 }}>
                        <TextField {...startProps} fullWidth size="small" />
                        <TextField {...endProps} fullWidth size="small" />
                      </Box>
                    )}
                  />
                </LocalizationProvider>
              </Box>
            )}
            <Box sx={{ display: "flex", gap: "10px" }}>
              {(type === "Send Diamonds" || type === "Send Rcoins") && (
                <Button
                  variant="contained"
                  color="error"
                  onClick={handleReset}
                  sx={{ borderRadius: "7px" }}
                >
                  Reset
                </Button>
              )}
              {exportTypes.includes(type) && (
                <Button
                  variant="contained"
                  color="error"
                  sx={{ borderRadius: "7px" }}
                  onClick={() => exportToExcel(data, type)}
                  disabled={!Array.isArray(data) || data.length === 0}
                >
                  Export
                </Button>
              )}
            </Box>
          </Toolbar>
          <TableContainer
            sx={{
              maxHeight: "67vh",
            }}
          >
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  {(type === "All Banners" ||
                    type === "Inactive Banners" ||
                    type === "Active Banners" ||
                    type === "Withdraw Payment Methods" ||
                    type === "Sub Admins" ||
                    type === "Profile Tags" ||
                    type === "Assign Profile Tags" ||
                    type === "Special RID" ||
                    type === "Images" ||
                    type === "Families" ||
                    type === "Diamond Packages" ||
                    type === "Sending Level" ||
                    type === "Hosting Level" ||
                    type === "Permissions" ||
                    type === "Scheduled PKs" ||
                    type === "Product Categories" ||
                    type === "Gift" ||
                    type === "Live Stream Tags" ||
                    type === "Assign Livestream Tag" ||
                    type === "Products" ||
                    type === "All Agencies" ||
                    type === "All Svip" ||
                    type === "Family Rule" ||
                    type === "Merchants") && (
                    <TableCell padding="checkbox">
                      <Checkbox
                        color="primary"
                        indeterminate={
                          selected?.length > 0 &&
                          selected?.length < data?.length
                        }
                        checked={
                          data?.length > 0 && selected?.length === data?.length
                        }
                        onChange={
                          type === "Send Diamonds" ? "" : handleSelectAllClick
                        }
                      />
                    </TableCell>
                  )}
                  {headCells.map((headCell) => (
                    <TableCell
                      key={headCell.id}
                      align={headCell.numeric ? "right" : "left"}
                      sx={{
                        whiteSpace: "nowrap",
                        fontWeight: "bold",
                        fontSize: "15px",
                      }}
                    >
                      {headCell.label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {loading ? (
                  <TableRow>
                    <TableCell colSpan={headCells.length + 1}>
                      <LinearIndeterminate />
                    </TableCell>
                  </TableRow>
                ) : Array.isArray(data) ? (
                  data?.map((row, index) => {
                    const isItemSelected = isSelected(row.id);
                    const labelId = `enhanced-table-checkbox-${index}`;
                    return (
                      <TableRow
                        hover
                        role="checkbox"
                        aria-checked={isItemSelected}
                        tabIndex={-1}
                        key={row.id}
                        selected={isItemSelected}
                      >
                        {(type === "All Banners" ||
                          type === "Inactive Banners" ||
                          type === "Active Banners" ||
                          type === "Withdraw Payment Methods" ||
                          type === "Sub Admins" ||
                          type === "Profile Tags" ||
                          type === "Assign Profile Tags" ||
                          type === "Special RID" ||
                          type === "Images" ||
                          type === "Families" ||
                          type === "Diamond Packages" ||
                          type === "Sending Level" ||
                          type === "Hosting Level" ||
                          type === "Permissions" ||
                          type === "Scheduled PKs" ||
                          type === "Product Categories" ||
                          type === "Gift" ||
                          type === "Live Stream Tags" ||
                          type === "Assign Livestream Tag" ||
                          type === "Products" ||
                          type === "All Agencies" ||
                          type === "All Svip" ||
                          type === "Family Rule" ||
                          type === "Merchants") && (
                          <TableCell
                            padding="checkbox"
                            onClick={() =>
                              type === "Send Diamonds"
                                ? null
                                : handleClick(row?.id)
                            }
                          >
                            <Checkbox
                              color="primary"
                              checked={isItemSelected}
                              inputProps={{ "aria-labelledby": labelId }}
                            />
                          </TableCell>
                        )}

                        {renderRow(row)}
                      </TableRow>
                    );
                  })
                ) : (
                  <TableRow>
                    <TableCell colSpan={headCells.length + 1}>
                      No data available
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
            {(type === "Donation Log" ||
              type === "Wallet Transaction" ||
              type === "Gifter Ranking") && (
              <>
                {!rid && (
                  <>
                    <TableRow>
                      <TableCell
                        colSpan={headCells.length + 1}
                        sx={{ position: "relative", left: "30vw" }}
                      >
                        Rid Must Reqiured
                      </TableCell>
                    </TableRow>
                  </>
                )}
              </>
            )}
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={rowsOptions}
            component="div"
            count={totalRecords}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Paper>
      </Box>
      <AlertDialog
        open={openDialog}
        onDelete={handleDelete}
        onCancel={() => setOpenDialog(false)}
      />
      <AddPermision
        open={openAddPermisionDialog}
        setOpen={closeDialog}
        Modeltype={Modeltype}
        Modeldata={Modeldata}
      />
      <AssignTagDialog
        open={openAssignTagModel}
        setOpen={setOpenAssignTagModel}
        data={Modeldata}
        type={Modeltype}
      />
      <AssignProfileTagDialog
        open={openAssignProfileTagModel}
        setOpen={setOpenAssignProfileTagModel}
        data={Modeldata}
        type={Modeltype}
      />
      <AddCategories
        open={openAddCategoriesDialog}
        setOpen={closeDialog}
        Modeltype={Modeltype}
        Modeldata={Modeldata}
      />
      <AddTag
        open={openAddTagDialog}
        setOpen={closeDialog}
        Modeltype={Modeltype}
        Modeldata={Modeldata}
      />
      <ReasonDialog
        open={openReasonModel}
        setOpen={setOpenReasonModel}
        reason={Reason}
        setReason={setReason}
        onSubmit={handleSubmit}
      />
      <ImagesDialog
        open={openImageModel}
        setOpen={setOpenImageModel}
        data={imagesData}
      />
    </ThemeProvider>
  );

  return {
    tableUI,
  };
}
